import {connect} from 'react-redux'
import AmountView from '../components/AmountView'
import {N} from '../../../../../helpers'
import {appCall, appSetVal, appSetServerVal, appSetObj} from '../../../../../store/application'
import {initCustomer, changeNumber, resetCustomer} from "../../../../../store/customer";
import {PAYMENT_STATUS} from "../../../../../constants";
import SimpExp from '../../../../../helpers/external/simpexp'

const mapDispatchToProps = {
  appCall: appCall,
  appSetVal: appSetVal,
  appSetServerVal: appSetServerVal,
  appSetObj: appSetObj,

  initCustomer: initCustomer,
  changeNumber: changeNumber,
  resetCustomer: resetCustomer
};

const mapStateToProps = (state, ownProps) => {

  const {fee, discount_amount, customer_limit_amount, display_amount} = state.app.x_data;
  const {phone_number, customer_id, phone_number_valid, customer_init_loading} = state.customer;
  const {payments} = state.cart;
  const {mask} = state.app.product_data;

  const cartPaymentsInProcessing = _.filter(payments, p => p.payment_status === PAYMENT_STATUS.PAYMENT_WAIT_PROCESSING);

  return {
    show_amount_box: !!customer_id,

    display_amount: display_amount,
    requested_amount: N(display_amount) + N(fee),
    discount_amount,
    customer_limit_amount,
    fee,

    denominations: ownProps.denominations,

    phone_number,
    phone_number_valid: phone_number_valid === undefined || phone_number_valid,
    phone_number_input_disabled: !!(customer_init_loading || customer_id),
    phone_number_mask: ownProps.productPhoneMask ? new SimpExp(mask).gen('ї') : null,

    customer_id,
    customer_init_loading,
    show_customer_change: !!(!customer_init_loading && customer_id),
    disable_confirm_button: customer_init_loading || !phone_number,

    empty_shopping_cart: cartPaymentsInProcessing && cartPaymentsInProcessing.length <= 0,

    phoneDoubleCheck: ownProps.phoneDoubleCheck,
}
};

export default connect(mapStateToProps, mapDispatchToProps)(AmountView)


// WEBPACK FOOTER //
// ./src/components/Applications/shared/Amounts/containers/AmountContainer.js